module.exports = __webpack_public_path__ + "34736292/img/rename-icon.de4e673d.svg";